<ion-button [color]="color" expand="block" [disabled]="to.disabled || parsedUrls.length === 0" (click)="openModal()" *ngIf="!error">{{parsedLabel}}</ion-button>
<ion-button [color]="color" expand="block" [disabled]="true" *ngIf="error">{{errorMsg || parsedLabel}}</ion-button>
